'use strict';
var React = require('react');

class AddButtonComponent extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="pull-right">
                    <div className="un-btn-upload" id="itemUpload" onClick={() => this.props.uploadOrEditData()}><a>Add Item</a></div>
                </div>
            </React.Fragment>
        )
    }
}
module.exports = AddButtonComponent;